"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRegistrationStatus = void 0;
const immer_1 = __importDefault(require("immer"));
const dateFunctions = __importStar(require("../utils/dateFunctions"));
const setFunctions = __importStar(require("../utils/setFunctions"));
const constants_1 = require("../constants");
const gotoUser_1 = require("../actions/chats/gotoUser");
const getAllChats_1 = require("../actions/chats/getAllChats");
const getUpdatedChats_1 = require("../actions/chats/getUpdatedChats");
const markRemoteUserOnline_1 = require("../actions/users/markRemoteUserOnline");
const logout_1 = require("../actions/signin/logout");
const notifySessionExpired_1 = require("../actions/signin/notifySessionExpired");
const getCurrentUser_1 = require("../actions/users/getCurrentUser");
const getUsers_1 = require("../actions/users/getUsers");
const registerUser_1 = require("../actions/users/registerUser");
const updateMinutesSinceLastOnline_1 = require("../actions/users/updateMinutesSinceLastOnline");
const setProfileImage_1 = require("../actions/users/setProfileImage");
var UserRegistrationStatus;
(function (UserRegistrationStatus) {
    UserRegistrationStatus[UserRegistrationStatus["Unknown"] = 0] = "Unknown";
    UserRegistrationStatus[UserRegistrationStatus["NotRegistered"] = 1] = "NotRegistered";
    UserRegistrationStatus[UserRegistrationStatus["Registered"] = 2] = "Registered";
})(UserRegistrationStatus = exports.UserRegistrationStatus || (exports.UserRegistrationStatus = {}));
const initialState = {
    userRegistrationStatus: UserRegistrationStatus.Unknown,
    me: null,
    unknownUserIds: [],
    userDictionary: {},
    usersSyncedUpTo: null
};
exports.default = immer_1.default((state, event) => {
    var _a, _b, _c;
    switch (event.type) {
        case gotoUser_1.DIRECT_CHAT_CREATED: {
            const { user } = event.payload;
            const unknownUserIds = state.unknownUserIds;
            const userDictionary = state.userDictionary;
            setFunctions.remove(unknownUserIds, user.userId);
            if (!userDictionary.hasOwnProperty(user.userId)) {
                userDictionary[user.userId] = user;
            }
            break;
        }
        case getAllChats_1.GET_ALL_CHATS_SUCCEEDED:
        case getUpdatedChats_1.GET_UPDATED_CHATS_SUCCEEDED: {
            const { chats } = event.payload;
            const unknownUserIds = state.unknownUserIds;
            const userDictionary = state.userDictionary;
            const myUserId = state.me.userId;
            for (const chat of chats) {
                if (chat.kind === constants_1.CONFIRMED_DIRECT_CHAT) {
                    if (!userDictionary.hasOwnProperty(chat.them)) {
                        setFunctions.add(unknownUserIds, chat.them);
                    }
                }
                else if (chat.kind === constants_1.CONFIRMED_GROUP_CHAT) {
                    chat.participants.forEach((p) => {
                        if (p !== myUserId && !userDictionary.hasOwnProperty(p)) {
                            setFunctions.add(unknownUserIds, p);
                        }
                    });
                }
            }
            break;
        }
        case getCurrentUser_1.GET_CURRENT_USER_SUCCEEDED: {
            state.userRegistrationStatus = UserRegistrationStatus.Registered;
            state.me = Object.assign(Object.assign({}, event.payload), { imageBlobUrl: (_b = (_a = state.me) === null || _a === void 0 ? void 0 : _a.imageBlobUrl) !== null && _b !== void 0 ? _b : null });
            break;
        }
        case getCurrentUser_1.GET_CURRENT_USER_FAILED: {
            state.userRegistrationStatus = UserRegistrationStatus.NotRegistered;
            state.me = null;
            break;
        }
        case getUsers_1.GET_USERS_SUCCEEDED: {
            const { request, result } = event.payload;
            const unknownUserIds = state.unknownUserIds;
            const userDictionary = state.userDictionary;
            for (const user of result.users) {
                setFunctions.remove(unknownUserIds, user.userId);
                userDictionary[user.userId] = user;
            }
            // Only bump the usersSyncedUpTo value if all users were requested
            if (request.users.length === Object.keys(userDictionary).length) {
                state.usersSyncedUpTo = result.timestamp;
            }
            break;
        }
        case markRemoteUserOnline_1.MARK_REMOTE_USER_ONLINE: {
            const userId = event.payload;
            if (state.userDictionary.hasOwnProperty(userId)) {
                const user = state.userDictionary[userId];
                if (user.minutesSinceLastOnline > 0) {
                    user.minutesSinceLastOnline = 0;
                    user.lastOnline = new Date();
                }
            }
            break;
        }
        case registerUser_1.REGISTER_USER_SUCCEEDED: {
            state.userRegistrationStatus = UserRegistrationStatus.Registered;
            state.me = event.payload;
            break;
        }
        case registerUser_1.REGISTER_USER_FAILED_USER_EXISTS: {
            state.userRegistrationStatus = UserRegistrationStatus.Registered;
            break;
        }
        case registerUser_1.REGISTER_USER_FAILED_USERNAME_EXISTS: {
            state.userRegistrationStatus = UserRegistrationStatus.NotRegistered;
            break;
        }
        case updateMinutesSinceLastOnline_1.UPDATE_MINUTES_SINCE_LAST_ONLINE: {
            for (const value of Object.values(state.userDictionary)) {
                const user = value;
                user.minutesSinceLastOnline = Math.floor(dateFunctions.getMinutesSince(user.lastOnline));
            }
            break;
        }
        case setProfileImage_1.SET_PROFILE_IMAGE_REQUESTED: {
            const { imageId, blobUrl } = event.payload;
            const user = state.me;
            if (user != null) {
                user.imageId = imageId;
                user.imageBlobUrl = blobUrl;
            }
            break;
        }
        case setProfileImage_1.SET_PROFILE_IMAGE_FAILED:
        case setProfileImage_1.SET_PROFILE_IMAGE_DATA_UPLOAD_FAILED: {
            const { userId } = event.payload;
            const user = userId === ((_c = state.me) === null || _c === void 0 ? void 0 : _c.userId)
                ? state.me
                : (state.userDictionary.hasOwnProperty(userId)
                    ? state.userDictionary[userId]
                    : null);
            URL.revokeObjectURL(user.imageBlobUrl);
            user.imageBlobUrl = null;
            user.imageId = null;
            break;
        }
        case notifySessionExpired_1.SESSION_EXPIRED:
        case logout_1.USER_LOGGED_OUT: {
            return initialState;
        }
    }
}, initialState);
